// Domains that may receive a post-login/logout redirect (BOLT apps sharing the SSO cookie).
const ALLOWED_DOMAINS = ["letsbolt.com.au", "letsbolt.io"];
const LOCAL_DOMAINS = ["letsbolt.test", "wishbone.test", "localhost"];

function isLocal() {
  const host = window.location.hostname;

  return host === "localhost" || host.endsWith(".test");
}

function isAllowedHost(hostname, domains) {
  return domains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}

/**
 * Resolves a ?redirect= value to a URL that is safe to navigate to, or null.
 * Relative paths and same-origin URLs are allowed; anything else must be https
 * (http only locally) on an allowed domain, which blocks javascript:, data: and
 * third-party URLs.
 */
export default function resolveSafeRedirect(value) {
  if (typeof value !== "string" || value === "") {
    return null;
  }

  let url;
  try {
    url = new URL(value, window.location.origin);
  } catch (e) {
    return null;
  }

  if (url.origin === window.location.origin) {
    return url;
  }

  const local = isLocal();
  const protocolAllowed = url.protocol === "https:" || (local && url.protocol === "http:");
  const domains = local ? [...ALLOWED_DOMAINS, ...LOCAL_DOMAINS] : ALLOWED_DOMAINS;

  return protocolAllowed && isAllowedHost(url.hostname, domains) ? url : null;
}
